/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramConnectionsUserControllerUpsertMutationRequest,
  TelegramConnectionsUserControllerUpsertMutationResponse,
  TelegramConnectionsUserControllerUpsert401,
} from '../types/TelegramConnectionsUserControllerUpsert.ts';

function getTelegramConnectionsUserUpsertUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/connections` as const };
  return res;
}

/**
 * {@link /api/user/telegram/connections}
 */
export async function telegramConnectionsUserUpsert(
  data: TelegramConnectionsUserControllerUpsertMutationRequest,
  config: Partial<RequestConfig<TelegramConnectionsUserControllerUpsertMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramConnectionsUserControllerUpsertMutationResponse,
    ResponseErrorConfig<TelegramConnectionsUserControllerUpsert401>,
    TelegramConnectionsUserControllerUpsertMutationRequest
  >({ method: 'POST', url: getTelegramConnectionsUserUpsertUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
